import { ContractProvider } from 'context/ContractContext'
import { DocumentProvider } from 'context/DocumentsContext'
import { AgentProvider } from 'context/ParticipantsOfProcessContext'
import Header from './components/header/Header'
import { AuthProvider } from './context/AuthContext'
import { LocationProvider } from './context/LocationContext'
import { ProjectProvider } from './context/ProjectsContext'
import AppRoutes from './Routes'
import './styles/scss/index.scss'

function App() {
	return (
		<div className='App'>
			<AuthProvider>
				<AgentProvider>
					<DocumentProvider>
						<LocationProvider>
							<ContractProvider>
								<ProjectProvider>
									<Header />
									<AppRoutes />
								</ProjectProvider>
							</ContractProvider>
						</LocationProvider>
					</DocumentProvider>
				</AgentProvider>
			</AuthProvider>
		</div>
	)
}
export default App
